import { Form, Input, InputNumber, Space } from "antd";
import TextArea from "antd/lib/input/TextArea";

export default function MccAndInustryEditor() {
  const mccAndIndustryFieldLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  };
  return (
    <>
      <Form.Item
        label="MCC"
        name="merchantCategoryCode"
        labelCol={mccAndIndustryFieldLayout.labelCol}
        wrapperCol={mccAndIndustryFieldLayout.wrapperCol}
        labelAlign="left"
      >
        <Input max={4} />
      </Form.Item>
      <Form.Item
        label="Industry"
        name="industry"
        labelCol={mccAndIndustryFieldLayout.labelCol}
        wrapperCol={mccAndIndustryFieldLayout.wrapperCol}
        labelAlign="left"
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="description"
        label="Description"
        labelCol={mccAndIndustryFieldLayout.labelCol}
        wrapperCol={mccAndIndustryFieldLayout.wrapperCol}
        labelAlign="left"
      >
        <TextArea
          showCount
          placeholder="Add business description"
          autoSize={{ minRows: 2, maxRows: 10 }}
        />
      </Form.Item>
      <Form.Item name="mccComments" labelAlign="left">
        <TextArea
          showCount
          placeholder="Add comments here"
          autoSize={{ minRows: 3, maxRows: 10 }}
        />
      </Form.Item>
    </>
  );
}
